import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { beneVerifyThisBank } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

export const useBankVerification = ({
  accountNumber,
  ifsc,
  legalName,
  autoVerify = true,
}) => {
  const dispatch = useDispatch();

  const { verifyBank, verifyBankisLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const isValidInput = accountNumber && ifsc?.length === 11;

  const verifyBankAccount = useCallback(() => {
    if (!isValidInput) return;

    dispatch(
      beneVerifyThisBank({
        bank_account: accountNumber,
        ifsc_code: ifsc,
        legal_name: legalName,
      }),
    );
  }, [dispatch, accountNumber, ifsc, legalName, isValidInput]);

  useEffect(() => {
    if (autoVerify && isValidInput) {
      verifyBankAccount();
    }
  }, [autoVerify, isValidInput, verifyBankAccount]);

  const virtualAccount =
    verifyBank?.verification_details?.[0]?.is_virtual === "Y";

  const accountHolder = verifyBank?.verification_details?.[0]?.full_name || "";

  return {
    verifyBankAccount,
    verified: verifyBank?.status ?? null,
    accountHolder,
    virtualAccount,
    details: verifyBank?.verification_details ?? null,
    loading: verifyBankisLoading,
    error: verifyBank?.errors ?? null,
  };
};
